import React, { useEffect, useState } from 'react'
import { useGetPricingDetailsForProductLazyQuery, useGetCheckoutUrlForExistingSubscriptionLazyQuery, PlanDetails, Addon, useGetPlanDetailsForProductLazyQuery, GetPlanDetailsForProductResponse, AddonDetails } from 'store/graphql/codegen/auto-gen/appPricing'
import { appPricingClient } from "../../store/graphql/apollo/clients";
import { ThriveStackProductName } from 'store/graphql/codegen/auto-gen/appPricing'
import { Heading1, ParagraphBody1, ParagraphBody2, CustomInputField, PrimaryButton, Title1 } from 'ts-widgets';
import { Spin } from 'antd';

const PricingInfo = () => {

    const [appliedPlan, setAppliedPlan] = useState<GetPlanDetailsForProductResponse>()

    const [availableAddons, setAvailableAddons] = useState<AddonDetails[]>([])

    const [getPlanDetailsForProduct] = useGetPlanDetailsForProductLazyQuery({
        client: appPricingClient,
        fetchPolicy: "no-cache"
    })
    
    const handleClick = () => {

        window.location.href = "/customer-analytics/pricing"

    }

    useEffect(() => {
        getPlanDetailsForProduct({
            variables: {
                input: {
                    thriveStackProductName: ThriveStackProductName.CustomerAnalytics,
                },
            },
            onCompleted: (data) => {
                console.log("AppPriceData", data)
                if (data) {
                    setAppliedPlan(data.getPlanDetailsForProduct)
                    setAvailableAddons(data.getPlanDetailsForProduct.addonDetails ?? [])
                }

            },
            onError: (err) => {
                console.error("API call failed:", err);
            }
        });
    }, []);


    return (
        <div className='flex h-screen w-screen items-center justify-center bg-gray-100'>
            {!appliedPlan ? (
                <div className="flex flex-col items-center mt-8">
                    <Spin size="large" />
                    <div className="mt-2 text-gray-600 text-sm">Loading...</div>
                </div>

            ) :
                (


                    <div className='flex flex-col w-[30%] border rounded-lg bg-white p-8 gap-6 shadow-md'>
                        <div className='text-4xl font-bold'>Active Plan</div>

                        <div className='flex flex-col gap-10'>

                            <div className='flex flex-col gap-4'>
                                <div className='font-semibold text-2xl'>{appliedPlan.planName}
                                    {
                                        appliedPlan.description ? <div className='font-normal text-base text-gray-600 mt-2'>{appliedPlan.description}</div> : <></>
                                    }
                                </div>


                                <div className='flex ms-4 items-center gap-4 w-full'>
                                    <div className="flex flex-shrink-0 w-[80px] font-medium">Purchased</div>:
                                    <div
                                        className="flex border rounded-lg ps-3 p-[1px] bg-[#b2f2bb] font-medium"
                                        style={{ width: `${appliedPlan.purchasedMaus * 2}%` }}
                                    >
                                        {appliedPlan.purchasedMaus} <div className='text-xs flex items-center ms-2'>MAUs</div>
                                    </div>
                                </div>
                                <div className='flex ms-4 items-center gap-4'>
                                    <div className="flex flex-shrink-0 w-[80px] font-medium">Used</div>:
                                    <div
                                        className='flex border rounded-lg ps-3 p-[1px] bg-[#FFD0A4] font-medium'
                                        style={{ width: `${appliedPlan.usedMaus * 2}%` }}
                                    >
                                        {appliedPlan.usedMaus} <div className='text-xs flex items-center ms-2'>MAUs</div>
                                    </div>
                                </div>
                            </div>


                            <div className='flex flex-col gap-4'>
                                <div className='font-semibold text-2xl'>Add-ons: </div>
                                {
                                    availableAddons.map((addon) => (
                                        <div className='flex gap-4 ms-4'>
                                            <div className='flex items-center font-medium w-52'>{addon.name} </div>:
                                            {addon.purchased ?
                                                (<>
                                                    <div className="flex border rounded-lg bg-[#b2f2bb] px-2 w-fit gap-4 items-center">Owned
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-4">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                        </svg>
                                                    </div>
                                                </>

                                                )
                                                : <div className='border rounded-lg bg-gray-100 px-2 w-36 text-gray-600 flex items-center'>Not purchased</div>
                                            }
                                        </div>
                                    ))
                                }

                            </div>

                            <PrimaryButton
                                onClick={handleClick}
                                className="w-fit p-2"
                            >Upgrade Plan</PrimaryButton>

                        </div>
                    </div>


                )}
        </div>
    )
}

export default PricingInfo